module.exports = __webpack_public_path__ + "img/can.ff90f6fc.svg";